// #region CONSTANTES
export const RESSOURCE_TERMINALS = "terminals";
export const RESSOURCE_TERMINALS_CLIENT = "terminals/client";
// #endregion

